import React, { createContext, useContext, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useSearchParamsSelector } from '../../../../shared/packages/searchParamsManager';
import { parseAcceptanceSlug } from '../../../../shared/packages/acceptance';
import { searchParamKeys } from '../../../../shared/configs/searchParams';

const Context = createContext();

export const useDesksConfigsParams = () => useContext(Context);

export const DesksConfigsParamsProvider = ({ children }) => {
  const history = useHistory();

  const acceptanceId = useSearchParamsSelector((state) => {
    const { acceptanceId } = parseAcceptanceSlug(
      state[searchParamKeys.acceptance]
    );
    return acceptanceId;
  });

  const serviceCompanyId = history.location.state.from.companyId;

  const params = useMemo(() => {
    return {
      acceptanceId,
      serviceCompanyId,
    };
  }, [acceptanceId, serviceCompanyId]);

  return <Context.Provider value={params}>{children}</Context.Provider>;
};
